"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceOption = exports.matcherMethodIgnoreCase = exports.isSame = exports.getNodeId = exports.getAriaLabelledBy = exports.ID_SEPARATOR = void 0;
var _isFunction = require("../utils/isFunction");
const ID_SEPARATOR = exports.ID_SEPARATOR = '-_-_-';
// e.g. café to cafe
const removeAccents = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const getNodeId = (listIdPrefix, key, groupIndex) => `${listIdPrefix}${ID_SEPARATOR}${key}${ID_SEPARATOR}${groupIndex}`;
exports.getNodeId = getNodeId;
const matcherMethodIgnoreCase = (haystack, needle, matcherMethod = 'startsWith') => {
  var _a, _b;
  return typeof haystack === 'string' && typeof needle === 'string' && ((_a = removeAccents(haystack)) === null || _a === void 0 ? void 0 : _a.toLowerCase()[matcherMethod]((_b = removeAccents(needle)) === null || _b === void 0 ? void 0 : _b.toLowerCase()));
};
exports.matcherMethodIgnoreCase = matcherMethodIgnoreCase;
const reduceOption = (option, fnOrKey) => {
  let result;
  if ((0, _isFunction.isFunction)(fnOrKey)) {
    result = fnOrKey(option);
  } else {
    result = option && option[fnOrKey];
  }
  return result || '';
};
exports.reduceOption = reduceOption;
const isSame = (option1, option2, itemKey) => reduceOption(option1, itemKey) === reduceOption(option2, itemKey);
exports.isSame = isSame;
const getAriaLabelledBy = ({
  ariaLabelledby,
  label,
  labelId
}) => {
  const labelledBy = [];
  if (ariaLabelledby) {
    labelledBy.push(ariaLabelledby);
  }
  if (label) {
    labelledBy.push(labelId);
  }
  return labelledBy.length > 0 ? labelledBy.join(' ') : undefined;
};
exports.getAriaLabelledBy = getAriaLabelledBy;